import { Phone, Mail, MapPin, Building2, Truck, Globe, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

export default function Impressum() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">

      <div className="relative pt-32 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)', backgroundSize: '40px 40px' }}></div>
        </div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-slate-600 rounded-2xl mb-6">
              <Building2 className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">Impressum</h1>
            <p className="text-xl text-slate-300 max-w-2xl mx-auto">
              Alle rechtlichen Informationen über Clean & Umzug Profis AG auf einen Blick.
            </p>
          </div>
        </div>
      </div>

      <main className="flex-grow bg-gradient-to-b from-slate-50 to-white py-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <button
            onClick={() => navigate('/')}
            className="mb-8 inline-flex items-center space-x-2 text-slate-700 hover:text-slate-900 font-medium transition group"
          >
            <ArrowLeft className="w-5 h-5 group-hover:-translate-x-1 transition-transform" />
            <span>Zurück zur Startseite</span>
          </button>
          <div className="grid md:grid-cols-3 gap-6 mb-12">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Building2 className="w-8 h-8 text-slate-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">Schweizer Firma</h3>
              <p className="text-sm text-slate-600">Registriert in Aarau</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Truck className="w-8 h-8 text-slate-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">Lizenziert</h3>
              <p className="text-sm text-slate-600">Professionelle Umzugsdienstleistungen</p>
            </div>
            <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
              <Globe className="w-8 h-8 text-slate-600 mb-3" />
              <h3 className="font-bold text-slate-900 mb-2">International</h3>
              <p className="text-sm text-slate-600">Schweiz & Deutschland</p>
            </div>
          </div>

          <div className="prose prose-slate max-w-none space-y-8 text-slate-700">
            <section className="bg-white p-8 rounded-xl shadow-sm border border-slate-200">
              <h2 className="text-2xl font-bold text-slate-900 mb-6">Angaben gemäß Schweizer Recht</h2>

              <div className="space-y-6">
                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-3">Firmenname</h3>
                  <p className="text-xl font-bold text-slate-900">Clean & Umzug Profis AG</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-3">Anschrift</h3>
                  <div className="flex items-start space-x-3">
                    <MapPin className="w-5 h-5 text-slate-600 mt-1 flex-shrink-0" />
                    <div>
                      <p>Hintere Bahnhofstrasse 83</p>
                      <p>5000 Aarau</p>
                      <p className="font-semibold mt-2">Schweiz</p>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-3">Kontakt</h3>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <Phone className="w-5 h-5 text-slate-600" />
                      <div>
                        <a href="tel:0800700100" className="text-slate-900 hover:text-blue-600 font-semibold">
                          0800 700 100
                        </a>
                        <span className="text-sm text-green-600 ml-2">(Gratis Hotline)</span>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Mail className="w-5 h-5 text-slate-600" />
                      <a href="mailto:info@umzugprofis.ch" className="text-slate-900 hover:text-blue-600">
                        info@umzugprofis.ch
                      </a>
                    </div>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-3">Handelsregister</h3>
                  <p>Eingetragen im Handelsregister des Kantons Aargau</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-3">UID-Nummer</h3>
                  <p>CHE-244.583.743</p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-3">Geschäftsführung</h3>
                  <p>Clean & Umzug Profis AG</p>
                </div>
              </div>
            </section>

            <section className="bg-white p-8 rounded-xl shadow-sm border border-slate-200">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Haftungsausschluss</h2>

              <div className="space-y-4">
                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-2">Haftung für Inhalte</h3>
                  <p className="leading-relaxed">
                    Die Inhalte unserer Seiten wurden mit grösster Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und
                    Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir für eigene
                    Inhalte auf diesen Seiten verantwortlich. Wir sind jedoch nicht verpflichtet, übermittelte oder gespeicherte
                    fremde Informationen zu überwachen.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-2">Haftung für Links</h3>
                  <p className="leading-relaxed">
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
                    Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
                    Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-semibold text-slate-800 mb-2">Urheberrecht</h3>
                  <p className="leading-relaxed">
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Schweizer
                    Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung ausserhalb der
                    Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                </div>
              </div>
            </section>

            <section className="bg-white p-8 rounded-xl shadow-sm border border-slate-200">
              <h2 className="text-2xl font-bold text-slate-900 mb-4">Leistungsgebiete</h2>
              <p className="leading-relaxed mb-4">
                Wir bieten professionelle Umzugsdienstleistungen zwischen der Schweiz und Deutschland an:
              </p>
              <ul className="grid md:grid-cols-2 gap-2">
                <li className="flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  <span>Komplettumzüge</span>
                </li>
                <li className="flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  <span>Teilumzüge</span>
                </li>
                <li className="flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  <span>Zollabwicklung</span>
                </li>
                <li className="flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  <span>Firmenumzüge</span>
                </li>
                <li className="flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  <span>Verpackungsservice</span>
                </li>
                <li className="flex items-center space-x-2">
                  <span className="w-1.5 h-1.5 bg-blue-600 rounded-full"></span>
                  <span>Zwischenlagerung</span>
                </li>
              </ul>
            </section>

            <section className="bg-blue-50 p-6 rounded-xl border border-blue-200">
              <h3 className="text-lg font-semibold text-slate-900 mb-3">Kontaktieren Sie uns</h3>
              <p className="text-slate-700 mb-4">
                Bei Fragen zu unserem Impressum oder unseren Dienstleistungen stehen wir Ihnen gerne zur Verfügung.
              </p>
              <div className="flex flex-col sm:flex-row gap-3">
                <a
                  href="tel:0800700100"
                  className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition"
                >
                  <Phone className="w-5 h-5 mr-2" />
                  0800 700 100
                </a>
                <a
                  href="mailto:info@umzugprofis.ch"
                  className="inline-flex items-center justify-center px-6 py-3 bg-white text-blue-600 font-semibold rounded-lg hover:bg-slate-50 transition border border-blue-600"
                >
                  <Mail className="w-5 h-5 mr-2" />
                  E-Mail senden
                </a>
              </div>
            </section>
          </div>
        </div>
      </main>
    </div>
  );
}
